import React from 'react';
import { IconButton, makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: 4,
      [theme.breakpoints.up('md')]: {
        padding: 8
      },
      [theme.breakpoints.up('lg')]: {
        padding: 12
      }
    }
  };
});

interface AppIconButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  alt?: string;
  src?: string;
  color?: string;
}

const AppIconButton: React.FC<AppIconButtonProps> = props => {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.root}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <img alt={props.alt} src={props.src} />
    </IconButton>
  );
};

export default AppIconButton;
